import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { BackfillBusinessesRequest } from '@cash-web/shared-util-protos/squareup/cash/customersearch/api/BackfillBusinesses.pb'
import { BackfillBusinessesResponse } from '@cash-web/shared-util-protos/squareup/cash/customersearch/api/BackfillBusinesses.pb'

export const backfillBusinesses = (request: BackfillBusinessesRequest, options?: CashRequestOptions) =>
  post<BackfillBusinessesRequest, BackfillBusinessesResponse>('/2.0/cash/backfill-businesses', request, {
    ...options,
    rejectOnError: true,
  })
